// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__11gwu","calendarButtons":"ClockData_calendarButtons__37b_M"};